/**
 * MAB API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { MetaGroup } from './metaGroup';
import { StartMethodInfo } from './startMethodInfo';


/**
 * Meta document model
 */
export interface MetaDocument { 
    /**
     * Meta document Id
     */
    id: number;
    /**
     * Document display name for Operator
     */
    captionOperator: string;
    /**
     * Document display name for Client
     */
    captionClient: string;
    /**
     * Meta document description
     */
    description?: string | null;
    /**
     * Meta document class name
     */
    docClassName: string;
    /**
     * Meta document class id
     */
    docClassID?: number;
    /**
     * Custom type id
     */
    customTypeID?: number;
    /**
     * Fields groups
     */
    groups: Array<MetaGroup>;
    startMethodInfo: StartMethodInfo;
}

